import { memo } from 'react';
import { Handle, Position } from 'reactflow';
import type { NodeProps } from 'reactflow';
import { BaseNodeUI } from './BaseNodeUI';
import { GitMerge } from 'lucide-react';

export default memo(({ selected, data }: NodeProps) => {
    return (
        <div className="relative h-full">
            <BaseNodeUI
                title={data.label || "Join"}
                icon={GitMerge}
                colorClass=""
                bgClass="bg-gradient-to-br from-purple-500 to-purple-700"
                selected={selected}
                hideHandles={true}
                isRunning={data?.executionStatus === 'Running'} executionStatus={data?.executionStatus}
            >
                {/* Labels for Layout could go here if BaseNodeUI supports children rendering inside the box */}
            </BaseNodeUI>

            {/* --- CUSTOM HANDLES --- */}

            {/* Left Input (Top-Left) */}
            <Handle
                type="target"
                position={Position.Left}
                id="left"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ top: '25%', left: -16 }}
                title="Left Input"
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-slate-400 rotate-45 transform -translate-x-0.5" />
            </Handle>
            {/* Label L */}
            <div className="absolute left-[-20px] top-[24%] -translate-y-1/2 text-[8px] font-bold text-slate-400 pointer-events-none">L</div>

            {/* Right Input (Bottom-Left) */}
            <Handle
                type="target"
                position={Position.Left}
                id="right"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ top: '75%', left: -16 }}
                title="Right Input"
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-slate-400 rotate-45 transform -translate-x-0.5" />
            </Handle>
            {/* Label R */}
            <div className="absolute left-[-20px] top-[74%] -translate-y-1/2 text-[8px] font-bold text-slate-400 pointer-events-none">R</div>

            {/* Success Output (Green) - Center Right */}
            <Handle
                type="source"
                position={Position.Right}
                id="success"
                className="!w-3 !h-3 !min-w-0 !min-h-0 !bg-transparent !border-0 flex items-center justify-center z-50 cursor-pointer"
                style={{ right: -16, top: '50%', transform: 'translateY(-50%)' }}
                title="Success"
            >
                <div className="w-1.5 h-1.5 border-t-[2px] border-r-[2px] border-emerald-500 rotate-45 transform -translate-x-0.5" />
            </Handle>
        </div>
    );
});
